import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { TextKey } from '@mews-commander/enums';
import { LocalizedText, withScopeContext } from '@mews/framework';
import { ColumnAlignment } from '@mews/b2b-ui';
import { ApplicationState } from '@mews-commander/types';
import { LocalizedDateFromUtc } from '@mews-commander/ui';
import { Table, TableWrapperElement } from '@mews-commander/ui/legacy';
import { ResourceCategoryName } from '../../../../../../../../components/commander-ui';
import {
    getSelectedReservationsUniqueCategoryIds,
    Entry,
    getResourceTableSource,
} from '../../../../../../selectors/spacesOverview';

const getResourceCategoryTypeColumns = (resourceCategoryIds: string[], serviceId: string) =>
    resourceCategoryIds.map((resourceCategoryId) => ({
        title: <ResourceCategoryName id={resourceCategoryId} serviceId={serviceId} short tooltipped />,
        columnAlignment: ColumnAlignment.Center,
        valueKey: resourceCategoryId,
        render: ({ categoryCountMap }: Entry) => categoryCountMap[resourceCategoryId],
    }));

const tableMapping = (resourceCategoryIds: string[], serviceId: string) => [
    {
        title: <LocalizedText textKey={TextKey.Date} />,
        valueKey: 'date',
        render: ({ date }: Entry) => <LocalizedDateFromUtc utcString={date} key={date} />,
    },
    ...getResourceCategoryTypeColumns(resourceCategoryIds, serviceId),
    {
        title: <LocalizedText textKey={TextKey.TotalResourcePlural} />,
        columnAlignment: ColumnAlignment.Center,
        valueKey: 'resourceCount',
    },
    {
        title: <LocalizedText textKey={TextKey.TotalPersonPlural} />,
        columnAlignment: ColumnAlignment.Center,
        valueKey: 'personCount',
    },
];

interface StateProps {
    source: Entry[];
    resourceCategoryIds: string[];
}

interface OwnProps {
    scope: string;
    serviceId: string;
}

type ResourcesTableProps = StateProps & OwnProps;

const ResourcesTable = ({ resourceCategoryIds, source, serviceId }: ResourcesTableProps) => (
    <TableWrapperElement>
        <Table mapping={tableMapping(resourceCategoryIds, serviceId)} source={source} />
    </TableWrapperElement>
);

export default withScopeContext(
    connect<StateProps, null, OwnProps, ApplicationState>(
        createStructuredSelector({
            source: getResourceTableSource,
            resourceCategoryIds: (state: ApplicationState, { scope, serviceId }: OwnProps) =>
                getSelectedReservationsUniqueCategoryIds(state, { scope, serviceId }),
        })
    )(ResourcesTable)
);
